import React from "react";
import styled from "styled-components";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

const Sortable = ({
  items,
  render,
  onSortEnd,
  axis,
  wrapper,
  pressDelay,
  ...rest
}) => (
  <SortableList
    axis={axis}
    items={items}
    render={render}
    wrapper={wrapper}
    onSortEnd={(props) => {
      document.body.style.cursor = "default";
      if (onSortEnd) onSortEnd(props);
    }}
    onSortStart={() => (document.body.style.cursor = "grabbing")}
    pressDelay={pressDelay}
    useWindowAsScrollContainer={true}
    {...rest}
  />
);

const SortableItem = SortableElement(({ children }) => children);

const SortableList = SortableContainer(
  ({ items, render, wrapper: Wrapper }) => (
    <Wrapper>
      {items.map((item, index) => (
        <SortableItem key={index} index={index}>
          {render(item, index)}
        </SortableItem>
      ))}
    </Wrapper>
  )
);

Sortable.defaultProps = {
  axis: "y",
  wrapper: ({ children }) => <div>{children}</div>,
  pressDelay: 200,
};

export default Sortable;
